import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Tabs, Row, Col, Button, Icon, Input } from 'antd'

import List from './List'
import CategoryPopup from '@components/Popup/CategoryPopup'
import MoveCategoryPopup from '@components/Popup/MoveCategoryPopup'

import filterCategories from './filterCategories'
import RelatedCategories from '@components/Popup/RelatedCategories'

@inject((store: any) => {
    const { categoriesStore, popupStore } = store
    return { categoriesStore, popupStore }
})
@observer
class Categories extends Component<any, any> {
    state = {
        loading: true,
        filterValue: null,
        filterd: [],
        filteredParents: {},
        expandedCats: []
    }

    componentDidMount() {
        this.getCategories('POLICY', { filterValue: '' })
    }

    getCategories = async (type, filters) => {
        const { categoriesStore } = this.props
        await categoriesStore.updateCategoriesList(type, ['name', 'parent_id', 'id'])
        await this.filterCategories(filters)
        this.setState({ loading: false })
    }

    filterCategories = async filters => {
        const { filterValue } = filters
        await this.setState({ filterValue })
        const filtered = await filterCategories(filterValue, this.props.categoriesStore)
        if ('preserveExpand' in filters) {
            const { filterd, filteredParents } = filtered
            this.setState({ filterd, filteredParents })
        } else {
            this.setState({ ...filtered })
        }
    }

    setExanded = expandedCats => {
        this.setState({ expandedCats })
    }

    render() {
        const { TabPane } = Tabs
        const { loading, filterValue } = this.state
        const { categoriesStore } = this.props

        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader onBack={() => window.history.back()} title="קטגוריות" subTitle="בחר את סוג הקטגוריות" />
                <Row style={{ padding: '0 2rem' }}>
                    <Col>
                        <Tabs onChange={e => this.getCategories(e, { filterValue: '' })} type="card">
                            <TabPane tab="קטגוריות פוליסות" key="POLICY" />
                            <TabPane tab="קטגוריות מה מגיע לי" key="USER_AREA" />
                            <TabPane tab="קטגוריות כל הבריאות" key="HEALTH_RIGHT" />
                        </Tabs>
                    </Col>
                </Row>
                <Row style={{ padding: '1rem 2rem 0rem', backgroundColor: 'white' }}>
                    {categoriesStore.editing ? (
                        <Col xs={4} style={{ padding: '0 0 0 1rem' }}>
                            <Button
                                size="large"
                                style={{ width: '100%' }}
                                onClick={() => this.props.popupStore.togglePopup('category', {})}
                            >
                                <Icon type="plus" />
                                הוספת קטגוריה
                            </Button>
                        </Col>
                    ) : (
                        ''
                    )}
                    <Col xs={categoriesStore.type !== 'HEALTH_RIGHT' ? 20 : 24}>
                        <Input.Search
                            value={filterValue}
                            placeholder="חפש קטגוריות על פי שם או מזהה"
                            size="large"
                            onChange={e => this.filterCategories({ filterValue: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row style={{ padding: '0 2rem 2rem', backgroundColor: 'white' }}>
                    <Col>
                        {categoriesStore.list.length > 0 && !loading ? (
                            <List loading={loading} {...this.state} setExpanded={e => this.setExanded(e)} />
                        ) : (
                            'מחפש קטגוריות...'
                        )}
                    </Col>
                </Row>
                <CategoryPopup
                    categoryUpdated={() =>
                        this.getCategories(categoriesStore.type, { filterValue, preserveExpand: true })
                    }
                />
                <RelatedCategories />
                <MoveCategoryPopup
                    categoryMoved={() =>
                        this.getCategories(categoriesStore.type, { filterValue, preserveExpand: true })
                    }
                />
            </Layout>
        )
    }
}

export default withRouter(Categories)
